import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  { content_message: string }
>("stores.customers.sendMessage");

export const sendMessage = {
  ...postApis,
};
